/**
 * SEC-40: a link space's address is opened only when it is http or https.
 * Anything else (`javascript:`, `data:`, `file:`…) would run or load in the
 * app's origin, where the session token lives, so it is never opened.
 */
export const isSafeExternalUrl = (value: string | null | undefined): boolean => {
  if (!value) return false
  try {
    const { protocol } = new URL(String(value).trim())
    return protocol === 'http:' || protocol === 'https:'
  } catch {
    return false
  }
}
